import { useMemo, useState } from "react";
import SectionHeading from "./SectionHeading";
import AnimeCard from "@/components/feature/AnimeCard";
import { lateNightAnime } from "@/mocks/anime";

const tabs = [
  { key: "all", label: "全部" },
  { key: "xuanyi", label: "悬疑" },
  { key: "kehuan", label: "科幻" },
  { key: "lianai", label: "恋爱" },
  { key: "richang", label: "日常" },
];

export default function LateNightSection() {
  const [active, setActive] = useState("all");

  const list = useMemo(
    () =>
      active === "all"
        ? lateNightAnime
        : lateNightAnime.filter((item) => item.genreKey === active),
    [active]
  );

  return (
    <section
      id="latenight"
      className="w-full bg-background-100 px-4 py-14 md:px-8 md:py-20"
    >
      <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
        <SectionHeading
          eyebrow="睡前专属片单"
          title="深夜追番专区"
          desc="挑出节奏偏慢、以氛围与对话为主的作品，适合戴耳机静静看完一集就睡。切类型标签即可在本区即时换片。"
        />
        <div
          role="tablist"
          aria-label="深夜专区类型切换"
          className="hide-scrollbar flex shrink-0 gap-1 overflow-x-auto rounded-full border border-background-200 bg-background-50 p-1"
        >
          {tabs.map((tab) => (
            <button
              key={tab.key}
              role="tab"
              type="button"
              aria-selected={active === tab.key}
              onClick={() => setActive(tab.key)}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors cursor-pointer ${
                active === tab.key
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-600 hover:bg-background-100"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {list.map((item) => (
          <article
            key={item.id}
            className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-3.5 transition-colors hover:border-secondary-300"
          >
            <div className="h-[132px] w-[94px] shrink-0 overflow-hidden rounded-md bg-background-100">
              <img
                src={item.cover}
                alt={`《${item.title}》深夜专区封面`}
                title={`${item.title} | 51动漫深夜追番`}
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="flex min-w-0 flex-1 flex-col">
              <div className="flex items-start justify-between gap-2">
                <h3 className="font-heading text-xl leading-tight text-foreground-950">
                  {item.title}
                </h3>
                <span className="inline-flex shrink-0 items-center gap-1 text-xs font-bold text-accent-700">
                  <i className="ri-star-fill text-[10px]" />
                  {item.score.toFixed(1)}
                </span>
              </div>
              <p className="mt-1 text-xs text-foreground-500">
                {item.genre} · 全 {item.episodes} 集 · {item.status}
              </p>
              <p className="mt-2 line-clamp-3 text-xs leading-relaxed text-foreground-600">
                {item.summary}
              </p>
              <div className="mt-auto flex flex-wrap gap-1.5 pt-2">
                <span className="rounded-full bg-accent-100 px-2 py-0.5 text-[11px] text-accent-900">
                  睡前推荐
                </span>
                {item.tags.map((tag) => (
                  <span
                    key={tag}
                    className="rounded-full bg-background-100 px-2 py-0.5 text-[11px] text-foreground-600"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}